import httpClient from '@/http-client'
import { baseMutations, baseState } from '@/store/mixins'
import { split } from 'lodash'

const BASE_URL = '/api/report/student-statistics'

export default {
  namespaced: true,
  state: {
    ...baseState,
    formViewDatas: []
  },
  mutations: {
    ...baseMutations,
    SET_VIEW_MODELS(state, { data, index }) {
      if (!index) {
        state.formViewDatas = data;
      } else {
        split(index, ",").forEach(el => {
          state.formViewDatas[el] = data[el];
        });
      }
    },
  },
  actions: {
    async previewPdf(context, data) {
      let response = await httpClient.post(`${BASE_URL}/preview-pdf`, data)
      return response
    },
    async exportExcel(context, data) {
      let response = await httpClient.post(`${BASE_URL}/export-excel`, data, {
        responseType: 'arraybuffer'
      })
      return response
    },
    async getFormViewModel(context, { params, index }) {
      let response = await httpClient.get(`${BASE_URL}/form-view-models`, { params: params });
      context.commit("SET_VIEW_MODELS", {
        data: response.data,
        index: index
      });
      return Promise.resolve(response);
    },
  }
}
